function hasDocumentWrapper(html) {
  return /<(html|head|body)\b/i.test(String(html || ''));
}

function looksLikeHtml(html) {
  return /<\/?[a-z][\s\S]*>/i.test(String(html || ''));
}

function escapeHtml(text) {
  return String(text || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function plainTextToHtml(text) {
  return escapeHtml(text)
    .replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;')
    .replace(/\r\n|\r|\n/g, '<br>');
}

export function parseMailHtml(html) {
  const sourceHtml = String(html || '');
  const isHtml = looksLikeHtml(sourceHtml);
  const parser = new DOMParser();
  const normalizedHtml = isHtml ? sourceHtml : plainTextToHtml(sourceHtml);
  const doc = parser.parseFromString(normalizedHtml, 'text/html');

  return {
    doc,
    root: doc.body,
    sourceHtml,
    normalizedHtml,
    hasDocumentWrapper: hasDocumentWrapper(sourceHtml),
    isPlainTextFallback: !isHtml,
  };
}

export function exportMailHtml(parsedResult) {
  if (!parsedResult || !parsedResult.doc) {
    return '';
  }

  return parsedResult.hasDocumentWrapper
    ? parsedResult.doc.documentElement.outerHTML
    : parsedResult.doc.body.innerHTML;
}
